import { Check, X } from "lucide-react"
import { Section, Eyebrow } from "./Section"

const FOR = [
  "Founders with a clear point of view",
  "Coaches and consultants with high-ticket offers",
  "Advisors and expert-led firms",
  "B2B founders who want stronger authority",
  "Existing podcasters ready to become more strategic",
  "New shows that need the right foundation",
  "Experts who value relationships over vanity metrics",
]

const NOT_FOR = [
  "Hobby podcasters and beginner creators",
  "People looking for cheap editing",
  "Businesses without a clear offer",
  "Hosts chasing downloads as the only goal",
  "Founders expecting instant ROI from a podcast",
  "People who want to outsource every human touchpoint",
]

export function ForWhom() {
  return (
    <Section id="for-whom" className="bg-surface">
      <div className="max-w-2xl">
        <Eyebrow>Fit</Eyebrow>
        <h2 className="display-2 mt-4">Built for experts who play the long game</h2>
        <p className="mt-5 text-lg text-ink-body">
          This is for established experts who want their podcast to become a more
          strategic part of how they build trust, authority, and relationships.
        </p>
      </div>

      <div className="mt-12 grid gap-5 md:grid-cols-2">
        <div className="rounded-xl border border-hairline bg-page p-7">
          <h3>This is for</h3>
          <ul className="mt-5 space-y-3">
            {FOR.map((item) => (
              <li key={item} className="flex items-start gap-3 text-ink-body">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-accent-display" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl border border-hairline bg-page p-7">
          <h3>This is not for</h3>
          <ul className="mt-5 space-y-3">
            {NOT_FOR.map((item) => (
              <li key={item} className="flex items-start gap-3 text-ink-muted">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-ink-muted" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  )
}
